export const name = 'externalComponent' as const
